import { useEffect, useState } from 'react'
import { firestore, db } from '../../firebase'
import { Table, Input, Space, Button, Statistic, Row, Col, Card, Typography } from 'antd'
import { CSVLink } from 'react-csv'
import moment from 'moment'

const { Title, Text } = Typography

const LeadsBlocked = () => {

  const [isFetching, setIsFetching] = useState(false)
  const [domainList, setDomainList] = useState([])
  const [emailList, setEmailList] = useState([])
  const [newDomain, setNewDomain] = useState(null)
  const [newEmail, setNewEmail] = useState(null)

  useEffect(() => {

    fetchHistory()

  }, [])

  const fetchHistory = async () => {

    setIsFetching(true)

    // fetch blocked domains
    const blockedDomainsRes = await firestore.collection('blockDomain')
      .orderBy('created', 'desc')
      .get()

    // fetch blocked emails
    const blockedEmailsRes = await firestore.collection('blockEmail')
      .orderBy('created', 'desc')
      .get()

    const domainData = blockedDomainsRes.docs.map((x, key) => ({ ...x.data(), key }))
    const emailData = blockedEmailsRes.docs.map((x, key) => ({ ...x.data(), key }))

    setDomainList(domainData)
    setEmailList(emailData)
    setIsFetching(false)
  }

  const handleNewDomain = async () => {

    // check domain
    if (newDomain.length === 0 || !newDomain.startsWith('@')) return

    // add to firebase
    await firestore.collection('blockDomain').add({
      value: newDomain,
      created: db.firestore.FieldValue.serverTimestamp()
    })

    // reload
    setNewDomain(null)
    fetchHistory()
  }

  const handleNewEmail = async () => {

    // check email
    if (newEmail.length === 0 || !newEmail.includes('@')) return
    
    // add to firebase
    await firestore.collection('blockEmail').add({
      value: newEmail.toLowerCase(),
      created: db.firestore.FieldValue.serverTimestamp()
    })

    // reload
    setNewEmail(null)
    fetchHistory()
  }

  const columns = [
    {
      width: 250,
      key: 'created',
      title: 'Blocked On',
      dataIndex: 'created',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.created - b.created,
      render: text => `${moment(text.toDate()).format('MM/DD/YY hh:mm A')}`
    }, {
      width: 250,
      key: 'value',
      title: 'Blocked Value',
      dataIndex: 'value',
      sorter: (a, b) => a.value.localeCompare(b.value)
    },
  ]

  return (
    <>
      <Title level={2}>Leads Blocked</Title>
      <Text type='secondary' style={{ marginBottom: '1em' }}>Add new domains and emails to be blocked</Text>
      <Row gutter={[16, 16]} justify='space-between' align='middle'>
        <Col span={8} style={{display: 'flex', flexDirection: 'column' }}>
          <Row>
            <Space.Compact style={{ width: '100%', margin: '1em 0' }}>
              <Input 
                placeholder='Add @domain to be blocked' 
                value={newDomain} 
                onChange={(e) => setNewDomain(e.target.value)}
                allowClear
              />
              <Button type='primary' onClick={handleNewDomain} loading={isFetching}>Submit</Button>
            </Space.Compact>
          </Row>
          <Row>
            <Space.Compact style={{ width: '100%', marginBottom: '1em' }}>
              <Input 
                placeholder='Add email to be blocked' 
                value={newEmail} 
                onChange={(e) => setNewEmail(e.target.value)}
                allowClear
              />
              <Button type='primary' onClick={handleNewEmail} loading={isFetching}>Submit</Button>
            </Space.Compact>
          </Row>
        </Col>
        <Col span={4}>
          <Button
            type='primary'
            loading={isFetching}
            onClick={fetchHistory}
          >
            Refresh Data
          </Button>
        </Col>
      </Row>

      <Row>
        {domainList.length > 0 &&
          <Col>
            <Card variant='borderless'>
              <Statistic title='Domains' value={domainList.length} />
            </Card>
          </Col>
        }

        {emailList.length > 0 &&
          <Col>
            <Card variant='borderless'>
              <Statistic title='Emails' value={emailList.length} />
            </Card>
          </Col>
        }
      </Row>

      <Row justify='space-between' align='middle'>
        <Table
          style={{ paddingTop: 20 }}
          loading={isFetching}
          columns={columns}
          dataSource={domainList}
          scroll={{ x: 1000, y: 500 }}
          size='small'
          title={() => (
            <>
              <Text strong>Blocked Domains</Text><br/>
              <CSVLink
                filename={'blocked_domains.csv'}
                data={domainList}
                className='btn btn-primary'
              >
                Export to CSV
              </CSVLink>
            </>
          )}
        />
      </Row>

      <Row justify='space-between' align='middle'>
        <Table
          style={{ paddingTop: 20 }}
          loading={isFetching}
          columns={columns}
          dataSource={emailList}
          scroll={{ x: 1000, y: 500 }}
          size='small'
          title={() => (
            <>
              <Text strong>Blocked Emails</Text><br/>
              <CSVLink
                filename={'blocked_emails.csv'}
                data={emailList}
                className='btn btn-primary'
              >
                Export to CSV
              </CSVLink>
            </>
          )}
        />
      </Row>
    </>
  )
}

export default LeadsBlocked